<script setup lang="ts">
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import UnstyledButton from '@/components/base/UnstyledButton.vue';

export type Section =
  | 'our-story'
  | 'our-family'
  | 'our-environment'
  | 'our-community'
  | 'our-mission'
  | 'our-guarantee';

const selectedSection = defineModel<Section>();

const sections = {
  'our-story': 'Our Story',
  'our-family': 'Our Nutty Family',
  'our-environment': 'Our Environment',
  'our-community': 'Our Community',
  'our-mission': 'Our Mission Statement',
  'our-guarantee': 'Our Guarantee',
};
</script>

<template>
  <ol class="list-none">
    <li
      v-for="(title, key) in sections"
      :key
      class="inline-block border border-solid hover:border-gray-500 ml-1 mb-1.5 rounded-sm hover:bg-nuts-neutral-200"
      :class="
        selectedSection === key ? 'bg-nuts-neutral-200 border-nuts-neutral-400' : 'border-gray-400'
      "
    >
      <UnstyledButton @click="selectedSection = key">
        <BaseBodyText class="px-2 no-underline text-nuts-neutral-800 hover:no-underline">
          {{ title }}
        </BaseBodyText>
      </UnstyledButton>
    </li>
  </ol>
</template>
